import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { OffersPushLineNarrow } from 'Components/lines/offers-push-line/OffersPushLineNarrow';
import { OffersPushLineLarge } from 'Components/lines/offers-push-line/OffersPushLineLarge';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
export const OffersPushLine = (props: CMSOffersPush) => {
  const { isTablet } = useResponsive();
  return (
    <SiteContainer className="Line" id={props.id}>
      {isTablet ? <OffersPushLineLarge {...props} /> : <OffersPushLineNarrow {...props} />}
    </SiteContainer>
  );
};
